import React from 'react'
import styled from '@emotion/styled'

const StyledOrgCode = styled.span`
    ${({ theme }) => /* css */ `
    margin-left: ${theme.spacing(1)};
  `}
    font-weight: 500;
`

interface Props {
    orgId: string
}

const OrgCode: React.FC<Props> = ({ orgId, ...rest }: Props) => <StyledOrgCode {...rest}>({orgId})</StyledOrgCode>

export default OrgCode
